import React, { HTMLAttributes } from 'react';
import { makeStyles } from 'tss-react/mui';

const ratio = 147 / 2560;

const useStyles = makeStyles({ name: 'BannerFooter' })(() => ({
	root: {
		paddingTop: ratio * 100 + '%',
		background: '#4a4a4a',
		clipPath: 'polygon(0 0, 100% calc(100% - 1px), 100% 100%, 0 100%)',
		marginBottom: -1
	}
}));

/**
 * @deprecated due to new CI/CD.
 * @param props 
 * @returns jsx
 */
export const FooterBanner: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {
	const { classes, cx } = useStyles();
	const { className, ...other } = props;
	return (
		<div className={cx(classes.root, className)} {...other} />
	);
};
